import React, { useState, useEffect } from 'react';
import './skills.css';
import UIDesign from '../../assets/uiux.png';
import WebDesign from '../../assets/webdesign.png';
import AppDesign from '../../assets/app-design.png';
import { Element } from 'react-scroll';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Skills = () => {
  const [showMore, setShowMore] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [showAllCourses, setShowAllCourses] = useState(false);
  const [isPhoneView, setIsPhoneView] = useState(window.innerWidth <= 700);

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });

    const handleResize = () => {
      setIsPhoneView(window.innerWidth <= 700);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleToggle = () => {
    setShowMore(!showMore);
  };

  const toggleCourses = () => {
    setShowAllCourses(!showAllCourses);
  };

  const renderCourseItem = (course, index, keyPrefix = 'course') => (
    <li
      key={`${keyPrefix}-${index}`}
      data-aos="fade-up"
      onClick={() => setSelectedCourse(course)}
    >
      <span className="courseName">{course.name}</span> <span className="courseCode">({course.code})</span>
    </li>
  );

  const courses = [
    { name: "Computer Science I", code: "CSCE 155E", description: "Introduction to problem solving with computers. Topics include problem solving methods, software development principles, computer programming, and computing in society." },
    { name: "Computer Science II", code: "CSCE 156", description: "Data structures, including linked lists, stacks, queues, and trees; algorithms, including searching, sorting, and recursion; programming language topics, including object-oriented programming; pointers, references, and memory management; design and implementation of a multilayer application with SQL database." },
    { name: "Computer Systems Engineering", code: "CSCE 231", description: "Introduction to organization, structure, and applications of computer systems. Boolean Logic, Digital Arithmetic, Processor Organization, C Programming, Machine Language Programming, Input/Output, Memory Organization and Management, Building Embedded System Application." },
    { name: "Intro to Discrete Structures", code: "CSCE 235", description: "Survey of elementary discrete mathematics. Elementary graph and tree theories, set theory, relations and functions, propositional and predicate logic, methods of proof, induction, recurrence relations, principles of counting, elementary combinatorics, and asymptotic notations." },
    { name: "Unix Programming Environment", code: "CSCE 251", description: "Introduction to the Unix operating system. Unix file system. Unix tools and utilities. Shell programming." },
    { name: "Data Structures and Algorithms", code: "CSCE 310", description: "A review of algorithm analysis, asymptotic notation, and solving recurrence relations. Advanced data structures and their associated algorithms, heaps, priority queues, hash tables, trees, binary search trees, and graphs. Algorithmic techniques, divide and conquer, transform and conquer, space-time trade-offs, greedy algorithms, dynamic programming, randomization, and distributed algorithms. Introduction to computability and NP-completeness." },
    { name: "Programming Language Concepts", code: "CSCE 322", description: "List-processing, string-processing, and other types of high-level programming languages. Fundamental concepts of data types, control structures, operations, and programming environments of various programming languages. Analysis, formal specification, and comparison of language features." },
    { name: "Software Engineering", code: "CSCE 361", description: "Techniques used in the disciplined development of large software projects. Software requirements analysis and specifications, program design, coding and integration testing, and software maintenance. Software estimation techniques, design tools, and complexity metrics." },
    { name: "Data Modeling Systems Development", code: "CSCE 411", description: "Concepts of relational and object-oriented data modeling through the process of data model development including conceptual, logical and physical modeling. Techniques for identifying and creating relationships between discrete data members, reasoning about how data modeling and analysis are incorporated in system design and development, and specification paradigms for data models. Common tools and technologies for engineering systems and frameworks for integrating data. Design and analysis of algorithms and techniques for identification and exploration of data relationships, such as Bayesian probability and statistics, clustering, map-reduce, and web-based visualization." },
    { name: "Design and Analysis of Algorithms", code: "CSCE 423", description: "Mathematical preliminaries. Strategies for algorithm design, including divide-and-conquer, greedy, dynamic programming and backtracking. Mathematical analysis of algorithms. Introduction to NP-Completeness theory, including the classes P and NP, polynomial transformations and NP-complete problems." },
    { name: "Cybersecurity: Big Data and Cloud", code: "CSCE 443", description: "Covers the cybersecurity threat landscape and the mitigation strategies for Big Data, Cloud environments and Cryptocurrencies. Discusses emerging technologies and frameworks such as End-to-end encryption, Blockchains, Smart Contracts, OpenID Connect and OAuth2.0 as promising solutions to ensure data confidentiality and privacy." },
    { name: "Operating Systems Principles", code: "CSCE 451", description: "Organization and structure of operating systems. Control, communication, and synchronization of concurrent processes. Processor and job scheduling. Memory organization and management including paging, segmentation, and virtual memory. Resource management. Deadlock avoidance, detection, recovery. File system concepts and structure. Protection and security. Substantial programming." },
    { name: "Secure Software Engineering", code: "CSCE 469", description: "Introduction to concepts, principles and state-of-the-art methods in creating and maintaining secure software systems." },
    { name: "Computer Science Professional Development", code: "CSCE 486", description: "Preparation for the senior design project. Professional practice through familiarity with current tools, resources, and technologies. Professional standards, practices and ethics, and the oral and written report styles used specifically in the field of computer science." },
    { name: "Computer Science Senior Design Project", code: "CSCE 487", description: "A substantial computer science project requiring design, planning and scheduling, teamwork, written and oral communications, and the integration and application of technical and analytical aspects of computer science and software engineering." },
  ];

  return (
    <Element name="about">
      <section id="skills" className="skills">
        <span className="skillTitle">About Me</span>
        <span className={`skillDesc ${showMore ? 'expanded' : ''}`}>
          <p>I was born in Lincoln, Nebraska in 2004 to two Bosnian parents. My parents came to America for the chance at opportunity for their children while fleeing from the Bosnian civil war.</p>

          <p>Growing up, I was inspired by my family’s resilience. My mother worked tirelessly to support us after my father passed away in a trucking accident when I was just two years old. Seeing my older brother step up to help our family during such a difficult time left a lasting impression on me and instilled the importance of responsibility, hard work, and education.</p>

          <p>When I started school, I quickly developed a passion for learning. I was curious about the world and loved solving problems. As I grew older, I discovered my love for computers and software, which led me to pursue a degree in Computer Science.</p>

          <span className={`moreText ${showMore ? 'show' : 'hide'}`}>
            <p>While I’m proud of my academic journey, what truly defines me is my eagerness to learn and grow. I thrive in environments where I can tackle challenges, collaborate with others, and absorb new knowledge.</p>

            <p>Now, as I work towards starting my career in software development, I’m eager to bring this mindset to the industry. I’m especially excited about opportunities to learn from experienced professionals, tackle meaningful projects, and make an impact.</p>
          </span>
        </span>
        <button className="seeMoreBtn" onClick={handleToggle}>
          {showMore ? 'See Less' : 'See More'}
        </button>

        <div className="skillBars">
          <div className="skillBar">
            <img src={UIDesign} alt="UIDesign" className="skillBarImg" />
            <div className="skillBarText">
              <h2>The Quote I Live By</h2>
              <p>"Success is not in never falling, but in rising every time we fall."
                <span className="quoteAuthor">– Confucius</span>
              </p>
            </div>
          </div>

          <div className="skillBar">
            <img src={WebDesign} alt="WebDesign" className="skillBarImg" />
            <div className="skillBarText">
              <h2>My Work Ethic</h2>
              <p>I'm always focused on efficiency, consistency, and high quality results when working.</p>
            </div>
          </div>

          <div className="skillBar">
            <img src={AppDesign} alt="AppDesign" className="skillBarImg" />
            <div className="skillBarText">
              <h2>Willingness to Learn</h2>
              <p>I am always looking to expand my skills and knowledge while being ready to challenge myself.</p>
            </div>
          </div>
        </div>

        <div className="educationCard">
          <h2 className="educationTitle">Education</h2>
          <p className="education-details">Pursuing Bachelor in Computer Science, University of Nebraska Lincoln</p>
          <p className="education-details">Expected Graduation Date: December 2025</p>

          <div className="courseworkCard">
            <h3 className="courseworkTitle">Relevant Coursework</h3>
            <ul className="courseworkList">
              {(isPhoneView ? courses.slice(0, 6) : courses).map((course, index) =>
                renderCourseItem(course, index, 'base')
              )}
            </ul>

            {isPhoneView && courses.length > 6 && (
              <div className={`extraCoursework ${showAllCourses ? 'show' : 'hide'}`}>
                <ul className="courseworkList courseworkListExtra">
                  {courses.slice(6).map((course, index) =>
                    renderCourseItem(course, index, 'extra')
                  )}
                </ul>
              </div>
            )}

            {isPhoneView && courses.length > 6 && (
              <button
                className={`seeMoreCoursesBtn ${showAllCourses ? 'coursesExpanded' : 'coursesCollapsed'}`}
                onClick={toggleCourses}
              >
                {showAllCourses ? 'See Less' : 'See More'}
              </button>
            )}

            {selectedCourse && (
              <div className="modalOverlay" onClick={() => setSelectedCourse(null)}>
                <div className="modalContent" onClick={(e) => e.stopPropagation()}>
                  <h2>{selectedCourse.name} <span className="courseCode">({selectedCourse.code})</span></h2>
                  <p>{selectedCourse.description}</p>
                  <button onClick={() => setSelectedCourse(null)}>Close</button>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </Element>
  );
};

export default Skills;
